/**
 * Wraps backend validation errors.
 */
export class ErrorBag {
  constructor(private errors: Record<string, string[]> = {}) {}

  public all(): Record<string, string[]> {
    return this.errors;
  }

  public getError(key: string): string | null {
    const error = this.errors[key];

    if (Array.isArray(error)) {
      return error && error.length > 0 ? error[0] : null;
    }

    return error ?? null;
  }

  public has(key: string): boolean {
    return key in this.errors;
  }

  public hasErrors(): boolean {
    return Object.keys(this.errors).length > 0;
  }

  public clear(): void {
    this.errors = {};
  }

  /**
   * Get the first error. Useful if there are multiple errors and you don't
   * know which key has failed, but want to provide feedback that there was
   * an error.
   */
  public first(): string | null {
    for (const key in this.errors) {
      const messages = this.errors[key];

      if (Array.isArray(messages) && messages.length > 0) {
        return messages[0];
      }
    }

    return null;
  }
}
